export const themeBorderColor = 'GREYSCALE.SATELLITE';
export const createTextFieldBorderColors = (color = themeBorderColor) => ({
  borderTopColor: `${color} !important`,
  borderRightColor: `${color} !important`,
  borderBottomColor: `${color} !important`,
  borderLeftColor: `${color} !important`
});